import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

// Define API endpoints
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log(process.env);

export const API_ENDPOINTS = {
  login: `${API_BASE_URL}/api/v1/user/login`,
  logout: `${API_BASE_URL}/api/v1/user/logout`,
  saveUser: `${API_BASE_URL}/api/v1/admin/save-user`,
  saveSalesUser: `${API_BASE_URL}/api/v1/sales-admin/save-user`,
  saveContentAdminUser: `${API_BASE_URL}/api/v1/content-admin/save-user`,
  updtaeUser: `${API_BASE_URL}/api/v1/admin/update-user`,
  updtaeSalesUser: `${API_BASE_URL}/api/v1/sales-admin/update-user`,
  updateContentAdminUser: `${API_BASE_URL}/api/v1/content-admin/update-user`,
  userDetails: `${API_BASE_URL}/api/v1/admin/admin-users`,

  savePost: `${API_BASE_URL}/api/v1/junior-editor/save-post`,
  savePostChief: `${API_BASE_URL}/api/v1/chief-editor/save-post`,
  savePostUploader: `${API_BASE_URL}/api/v1/uploader/save-post`,

  updateSectorCheif: `${API_BASE_URL}/api/v1/chief-editor/update-sector `,
  updatePost: `${API_BASE_URL}/api/v1/junior-editor/update-post`,
  updatePostCheif: `${API_BASE_URL}/api/v1/chief-editor/update-post`,
  updatePostUploader: `${API_BASE_URL}/api/v1/uploader/update-post`,
  updatePostPublisher: `${API_BASE_URL}/api/v1/publisher/update-post`,
  getDashbaordPosts: `${API_BASE_URL}/api/v1/dashboard/get-posts`,
  getPosts: `${API_BASE_URL}/api/v1/junior-editor/get-posts`,
  getPostsCheif: `${API_BASE_URL}/api/v1/chief-editor/get-posts`,
  getPostsUploader: `${API_BASE_URL}/api/v1/uploader/get-posts`,
  getPostsPublisher: `${API_BASE_URL}/api/v1/publisher/get-posts`,
  getPostsCA: `${API_BASE_URL}/api/v1/content-admin/get-posts`,
  getPostsDetails: `${API_BASE_URL}/api/v1/junior-editor/post`,
  getPostsDetailsCheif: `${API_BASE_URL}/api/v1/chief-editor/post`,
  getPostsDetailsUploader: `${API_BASE_URL}/api/v1/uploader/post`,
  getPostsDetailsPublisher: `${API_BASE_URL}/api/v1/publisher/post`,
  getCAPostDetails: `${API_BASE_URL}/api/v1/content-admin/post`,
  getStatusChief: `${API_BASE_URL}/api/v1/chief-editor/post-history`,
  getStatusJunior: `${API_BASE_URL}/api/v1/junior-editor/post-history`,
  getStatusPublisher: `${API_BASE_URL}/api/v1/publisher/post-history`,
  getStatusUploader: `${API_BASE_URL}/api/v1/uploader/post-history`,
  getStatusContentAdmin: `${API_BASE_URL}/api/v1/content-admin/post-history`,
  saveCompanyCheif: `${API_BASE_URL}/api/v1/chief-editor/save-company`,
  saveCompanyJunior: `${API_BASE_URL}/api/v1/junior-editor/save-company`,

  updateCompanyCheif: `${API_BASE_URL}/api/v1/chief-editor/update-company`,
  updateCompanyJunior: `${API_BASE_URL}/api/v1/junior-editor/update-company`,

  getCompanyCheif: `${API_BASE_URL}/api/v1/chief-editor/get-companies`,
  getCompanyJunior: `${API_BASE_URL}/api/v1/junior-editor/get-companies`,
  getCompanyUploader: `${API_BASE_URL}/api/v1/uploader/get-companies`,
  getCompanyPublisher: `${API_BASE_URL}/api/v1/publisher/get-companies`,
  getCompany: `${API_BASE_URL}/api/v1/post/get-companies`,

  getEditCompanyCheif: `${API_BASE_URL}/api/v1/chief-editor/company`,
  getEditCompanyJunior: `${API_BASE_URL}/api/v1/junior-editor/company`,
  getEditCompanyUploader: `${API_BASE_URL}/api/v1/uploader/company`,

  saveSectorChief: `${API_BASE_URL}/api/v1/chief-editor/save-sector`,

  saveTagChief: `${API_BASE_URL}/api/v1/chief-editor/save-tag`,
  saveTagJunior: `${API_BASE_URL}/api/v1/junior-editor/save-tag`,
  saveTagUploader: `${API_BASE_URL}/api/v1/uploader/save-tag`,

  updateTagChief: `${API_BASE_URL}/api/v1/chief-editor/update-tag`,
  updateTagJunior: `${API_BASE_URL}/api/v1/junior-editor/update-tag`,
  updateTagUploader: `${API_BASE_URL}/api/v1/uploader/update-tag`,

  getSectorChief: `${API_BASE_URL}/api/v1/chief-editor/get-sectors`,
  getSectorJunior: `${API_BASE_URL}/api/v1/junior-editor/get-sectors`,
  getSectorUploader: `${API_BASE_URL}/api/v1/uploader/get-sectors`,
  getSectorPub: `${API_BASE_URL}/api/v1/publisher/get-sectors`,
  getSubscriberApi: `${API_BASE_URL}/api/v1/sales-admin/get-subscriptions`,
  getTagChief: `${API_BASE_URL}/api/v1/chief-editor/get-tags`,
  getTagJunior: `${API_BASE_URL}/api/v1/junior-editor/get-tags`,
  getTagUploader: `${API_BASE_URL}/api/v1/uploader/get-tags`,
  getTagPub: `${API_BASE_URL}/api/v1/publisher/get-tags`,

  deleteSecotorChief: `${API_BASE_URL}/api/v1/chief-editor/delete-sector`,
  deleteTagChief: `${API_BASE_URL}/api/v1/chief-editor/delete-tag`,
  deleteTagJunior: `${API_BASE_URL}/api/v1/junior-editor/delete-tag`,
  deleteTagUploader: `${API_BASE_URL}/api/v1/uploader/delete-tag`,

  tagApproveUploader: `${API_BASE_URL}/api/v1/uploader/send-tag-for-apprvl`,
  tagApproveJunior: `${API_BASE_URL}/api/v1/junior-editor/send-tag-for-apprvl`,
  tagApproveCE: `${API_BASE_URL}/api/v1/chief-editor/approve-tag`,

  getChiefContentUsers: `${API_BASE_URL}/api/v1/chief-editor/get-content-users`,
  getJuniorContentUser: `${API_BASE_URL}/api/v1/junior-editor/get-content-users`,
  getPublisherContentUser: `${API_BASE_URL}/api/v1/publisher/get-content-users`,
  getUploaderContentUser: `${API_BASE_URL}/api/v1/uploader/get-content-users `,

  getActiveJuniorEditors: `${API_BASE_URL}/api/v1/junior-editor/get-active-junior-editors`,
  getActivePublishers: `${API_BASE_URL}/api/v1/publisher/get-active-publishers`,
  getActiveCES: `${API_BASE_URL}/api/v1/chief-editor/get-active-users`,
  juniorEditorSelfAssigned: `${API_BASE_URL}/api/v1/junior-editor/assign-post`,
  publisherSelfAssigned: `${API_BASE_URL}/api/v1/publisher/assign-post`,
  ceSelfAssigned: `${API_BASE_URL}/api/v1/chief-editor/assign-post`,
  featured: `${API_BASE_URL}/api/v1/publisher/save-post-as-featured`,
  nonFeatured: `${API_BASE_URL}/api/v1/publisher/save-post-as-non-featured`,
  savePostAsDraft: `${API_BASE_URL}/api/v1/junior-editor/save-post-as-draft`,
  savePostPublish: `${API_BASE_URL}/api/v1/junior-editor/save-post-as-published`,

  salesUserDetails: `${API_BASE_URL}/api/v1/sales-admin/admin-users`,
  contentUserDetails: `${API_BASE_URL}/api/v1/content-admin/admin-users`,
  executiveUserDetails: `${API_BASE_URL}/api/v1/sales-executive/admin-users`,
  tlUserDetails: `${API_BASE_URL}/api/v1/sales-team-lead/admin-users`,
  smUserDetails: `${API_BASE_URL}/api/v1/sales-manager/admin-users`,

  adminUserData: `${API_BASE_URL}/api/v1/admin/admin-user`,
  contentUsersData: `${API_BASE_URL}/api/v1/content-admin/admin-user`,
  salesMangerUsersData: `${API_BASE_URL}/api/v1/sales-manager/admin-user`,
  salesTlUsersData: `${API_BASE_URL}/api/v1/sales-team-lead/admin-user`,
  countryData: `${API_BASE_URL}/api/v1/master/mt-country`,
  mtRoleData: `${API_BASE_URL}/api/v1/master/mt-roles`,
  salesUserData: `${API_BASE_URL}/api/v1/sales-admin/admin-user`,
  eligibilityApi: `${API_BASE_URL}/api/v1/user/eligibility`,
  changePassowrd: `${API_BASE_URL}/api/v1/logged-in-user/change-password`,
  userCount: `${API_BASE_URL}/api/v1/sales-admin/user-count`,

  postCount: `${API_BASE_URL}/api/v1/junior-editor/post-count`,
  postCountCheif: `${API_BASE_URL}/api/v1/chief-editor/post-count`,
  postCountUploader: `${API_BASE_URL}/api/v1/uploader/post-count`,
  postCountPublisher: `${API_BASE_URL}/api/v1/publisher/post-count`,
  salesTlUserCount: `${API_BASE_URL}/api/v1/sales-team-lead/user-count`,
  salesManagerUserCount: `${API_BASE_URL}/api/v1/sales-manager/user-count`,

  eventCount: `${API_BASE_URL}/api/v1/junior-editor/event-count`,
  eventCountCheif: `${API_BASE_URL}/api/v1/chief-editor/event-count`,
  eventCountUploader: `${API_BASE_URL}/api/v1/uploader/event-count`,
  eventCountPublisher: `${API_BASE_URL}/api/v1/publisher/event-count`,

  superAdmin_userCount: `${API_BASE_URL}/api/v1/admin/user-count`,
  transferUser: `${API_BASE_URL}/api/v1/sales-admin/transfer-user`,
  activateDeactivate: `${API_BASE_URL}/api/v1/sales-admin/activate-deactivate-user`,
  contentActivateDeactivate: `${API_BASE_URL}/api/v1/content-admin/activate-deactivate-user`,
  contentAdminCanInvite: `${API_BASE_URL}/api/v1/content-admin/cancel-invitation`,
  cancelInvitation: `${API_BASE_URL}/api/v1/sales-admin/cancel-invitation`,
  contentAdmResendInvitation: `${API_BASE_URL}/api/v1/content-admin/resend-invitation`,
  resendInvitation: `${API_BASE_URL}/api/v1/sales-admin/resend-invitation`,
  adminActivateDeactivate: `${API_BASE_URL}/api/v1/admin/activate-deactivate-user`,
  adminCancelInvitation: `${API_BASE_URL}/api/v1/admin/cancel-invitation`,
  adminResendInvitation: `${API_BASE_URL}/api/v1/admin/resend-invitation`,
  sendEmailVerify: `${API_BASE_URL}/api/v1/user/send-forget-pass-mail`,
  verifyForgetPass: `${API_BASE_URL}/api/v1/user/verify-forget-pass`,
  mtCurrency: `${API_BASE_URL}/api/v1/master/mt-currency`,
  salesAdminSaveLead: `${API_BASE_URL}/api/v1/sales-admin/save-lead`,
  salesManagerSaveLead: `${API_BASE_URL}/api/v1/sales-manager/save-lead`,
  salesTLSaveLead: `${API_BASE_URL}/api/v1/sales-team-lead/save-lead`,
  salesExicuteSaveLead: `${API_BASE_URL}/api/v1/sales-executive/save-lead`,
  salesAdminUpdateLeads: `${API_BASE_URL}/api/v1/sales-admin/update-lead`,
  salesManagerUpdateLeads: `${API_BASE_URL}/api/v1/sales-manager/update-lead`,
  salesExicuteUpdateLeads: `${API_BASE_URL}/api/v1/sales-executive/update-lead`,
  salesTlUpdateLeads: `${API_BASE_URL}/api/v1/sales-team-lead/update-lead`,
  mtCotinent: `${API_BASE_URL}/api/v1/master/mt-continent`,
  ClientpostCount: `${API_BASE_URL}/api/v1/dashboard/post-count`,
  dashboardeventCount: `${API_BASE_URL}/api/v1/dashboard/event-count`,
  markAdPaid: `${API_BASE_URL}/api/v1/payment/mark-as-paid`,

  salesAdminProposalUserData: `${API_BASE_URL}/api/v1/sales-admin/get-proposals`,
  salesTlProposalUserData: `${API_BASE_URL}/api/v1/sales-team-lead/get-proposals`,
  salesManagerProposalUserData: `${API_BASE_URL}/api/v1/sales-manager/get-proposals`,
  salesExecutiveProposalUserData: `${API_BASE_URL}/api/v1/sales-executive/get-proposals`,

  salesAdminDeclinedProposal: `${API_BASE_URL}/api/v1/sales-admin/decline-proposal`,
  salesTlDeclinedProposal: `${API_BASE_URL}/api/v1/sales-team-lead/decline-proposal`,
  salesManagerDeclinedProposal: `${API_BASE_URL}/api/v1/sales-manager/decline-proposal`,
  salesExecutiveDeclinedProposal: `${API_BASE_URL}/api/v1/sales-executive/decline-proposal`,

  getSalesAdminDeclinedProposal: `${API_BASE_URL}/api/v1/sales-admin/get-declined-proposals`,
  getSalesTlDeclinedProposal: `${API_BASE_URL}/api/v1/sales-team-lead/get-declined-proposals`,
  getSalesManagerDeclinedProposal: `${API_BASE_URL}/api/v1/sales-manager/get-declined-proposals`,
  getSalesExecutiveDeclinedProposal: `${API_BASE_URL}/api/v1/sales-executive/get-declined-proposals`,

  salesAdminActvtDclinProposal: `${API_BASE_URL}/api/v1/sales-admin/activate-declined-proposal`,
  salesTlActvtDclinProposal: `${API_BASE_URL}/api/v1/sales-team-lead/activate-declined-proposal`,
  salesExctActvtDclinProposal: `${API_BASE_URL}/api/v1/sales-executive/activate-declined-proposal`,
  salesManagerActvtDclinProposal: `${API_BASE_URL}/api/v1/sales-manager/activate-declined-proposal`,

  salesAdminBookProposal: `${API_BASE_URL}/api/v1/sales-admin/book-proposal`,
  salesTlBookProposal: `${API_BASE_URL}/api/v1/sales-team-lead/book-proposal`,
  salesManagerBookProposal: `${API_BASE_URL}/api/v1/sales-manager/book-proposal`,
  salesExecutiveBookProposal: `${API_BASE_URL}/api/v1/sales-executive/book-proposal`,

  editSalesAdminProposalBooking: `${API_BASE_URL}/api/v1/sales-admin/proposal-booking`,
  editSalesTlProposalBooking: `${API_BASE_URL}/api/v1/sales-team-lead/proposal-booking`,
  editSalesManagerProposalBooking: `${API_BASE_URL}/api/v1/sales-manager/proposal-booking`,
  editSalesExecutiveProposalBooking: `${API_BASE_URL}/api/v1/sales-executive/proposal-booking`,

  updateSalesAdminProposalBooking: `${API_BASE_URL}/api/v1/sales-admin/update-proposal-booking`,
  updateSalesTlProposalBooking: `${API_BASE_URL}/api/v1/sales-team-lead/update-proposal-booking`,
  updateSalesManagerProposalBooking: `${API_BASE_URL}/api/v1/sales-manager/update-proposal-booking`,
  updateSalesExecutiveProposalBooking: `${API_BASE_URL}/api/v1/sales-executive/update-proposal-booking`,

  salesAdminDownloadBookingForm: `${API_BASE_URL}/api/v1/sales-admin/get-booking-form`,
  salesTlDownloadBookingForm: `${API_BASE_URL}/api/v1/sales-team-lead/get-booking-form`,
  salesManagerDownloadBookingForm: `${API_BASE_URL}/api/v1/sales-manager/get-booking-form`,
  salesExecutiveDownloadBookingForm: `${API_BASE_URL}/api/v1/sales-executive/get-booking-form`,

  salesAdminDownloadSignedBookingForm: `${API_BASE_URL}/api/v1/sales-admin/download-signed-booking-form`,
  salesTlDownloadSignedBookingForm: `${API_BASE_URL}/api/v1/sales-team-lead/download-signed-booking-form`,
  salesManagerDownloadSignedBookingForm: `${API_BASE_URL}/api/v1/sales-manager/download-signed-booking-form`,
  salesExecutiveDownloadSignedBookingForm: `${API_BASE_URL}/api/v1/sales-executive/download-signed-booking-form`,

  submitSignedBookingForm: `${API_BASE_URL}/api/v1/lead/submit-signed-booking-form`,

  salesLeadsUsersData: `${API_BASE_URL}/api/v1/sales-admin/get-leads`,
  salesManagerUsersData: `${API_BASE_URL}/api/v1/sales-manager/get-leads`,
  salesTLUsersData: `${API_BASE_URL}/api/v1/sales-team-lead/get-leads`,
  salesExicuteUsersData: `${API_BASE_URL}/api/v1/sales-executive/get-leads`,
  salesGetLeadsApi: `${API_BASE_URL}/api/v1/sales-admin/lead`,
  salesManagerLeadsApi: `${API_BASE_URL}/api/v1/sales-manager/lead`,
  salesTlLeadsApi: `${API_BASE_URL}/api/v1/sales-team-lead/lead`,
  salesExicuteLeadsApi: `${API_BASE_URL}/api/v1/sales-executive/lead`,
  salesAdminDeclined: `${API_BASE_URL}/api/v1/sales-admin/decline-leads`,
  salesAdminConvertLeads: `${API_BASE_URL}/api/v1/sales-admin/convert-leads`,
  salesManagerDeclined: `${API_BASE_URL}/api/v1/sales-manager/decline-leads`,
  salesManagerConvertLeads: `${API_BASE_URL}/api/v1/sales-manager/convert-leads`,
  salesTLDeclined: `${API_BASE_URL}/api/v1/sales-team-lead/decline-leads`,
  salesTLActvtDclinLead: `${API_BASE_URL}/api/v1/sales-team-lead/activate-declined-leads`,
  salesAdminActvtDclinLead: `${API_BASE_URL}/api/v1/sales-admin/activate-declined-leads`,
  salesExctActvtDclinLead: `${API_BASE_URL}/api/v1/sales-executive/activate-declined-leads`,
  salesManagerActvtDclinLead: `${API_BASE_URL}/api/v1/sales-manager/activate-declined-leads`,
  salesTLConvertLeads: `${API_BASE_URL}/api/v1/sales-team-lead/convert-leads`,
  salesExcuteDeclined: `${API_BASE_URL}/api/v1/sales-executive/decline-leads`,
  salesExcuteConvertLeads: `${API_BASE_URL}/api/v1/sales-executive/convert-leads`,
  getSalesAdminDeclinedLeads: `${API_BASE_URL}/api/v1/sales-admin/get-declined-leads`,
  getSalesManagerDeclinedLeads: `${API_BASE_URL}/api/v1/sales-manager/get-declined-leads`,
  getTLDeclinedLeads: `${API_BASE_URL}/api/v1/sales-team-lead/get-declined-leads`,
  getExicuteDeclinedLeads: `${API_BASE_URL}/api/v1/sales-executive/get-declined-leads`,
  getSalesAdminAddedByUsers: `${API_BASE_URL}/api/v1/sales-admin/get-assigned-users`,
  getSalesManagerAddedByUsers: `${API_BASE_URL}/api/v1/sales-manager/get-assigned-users`,
  getSlesTeamLeadAddedByUsers: `${API_BASE_URL}/api/v1/sales-team-lead/get-assigned-users`,
  getSuperAdminAssignedUsers: `${API_BASE_URL}/api/v1/admin/get-assigned-users`,
  getPublishedPosts: `${API_BASE_URL}/api/v1/publisher/save-post-as-published`,

  getJuniorEditorAddedBy: `${API_BASE_URL}/api/v1/junior-editor/get-content-users`,
  getChiefEditorAddedBy: `${API_BASE_URL}/api/v1/chief-editor/get-content-users`,
  getPublisherAddedBy: `${API_BASE_URL}/api/v1/publisher/get-content-users`,

  getJuniorEditorAssignedTo: `${API_BASE_URL}/api/v1/junior-editor/get-content-users`,
  getChiefEditorAssignedTo: `${API_BASE_URL}/api/v1/chief-editor/get-content-users`,
  getUploaderAssignedTo: `${API_BASE_URL}/api/v1/uploader/get-content-users`,
  getPublisherAssignedTo: `${API_BASE_URL}/api/v1/publisher/get-content-users`,

  getPostManagement: `${API_BASE_URL}/api/v1/post-management/get-posts`,
  savePostManagement: `${API_BASE_URL}/api/v1/post-management/save-post-order`,
  deletePostManagement: `${API_BASE_URL}/api/v1/post-management/delete-post-order`,

  archiveCEAPi: `${API_BASE_URL}/api/v1/chief-editor/archive-or-unarchive-post`,
  archiveJEAPi: `${API_BASE_URL}/api/v1/junior-editor/archive-or-unarchive-post`,
  archiveUpAPi: `${API_BASE_URL}/api/v1/uploader/archive-or-unarchive-post`,
  archivePublishAPi: `${API_BASE_URL}/api/v1/publisher/archive-or-unarchive-post`,

  addEventForCE: `${API_BASE_URL}/api/v1/chief-editor/save-event`,
  addEventForJE: `${API_BASE_URL}/api/v1/junior-editor/save-event`,
  addEventForUploader: `${API_BASE_URL}/api/v1/uploader/save-event`,

  updateEventForCE: `${API_BASE_URL}/api/v1/chief-editor/update-event `,
  updateEventForJE: `${API_BASE_URL}/api/v1/junior-editor/update-event `,
  updateEventForUploader: `${API_BASE_URL}/api/v1/uploader/update-event `,
  updateEventForPub: `${API_BASE_URL}/api/v1/publisher/update-event`,

  // postMangement apis
  deletePostOrder: `${API_BASE_URL}/api/v1/post-management/delete-post-order`,
  savePostOrder: `${API_BASE_URL}/api/v1/post-management/save-post-order`,

  deleteUserSuperAdminImage: `${API_BASE_URL}/api/v1/admin/user-image`,
  deleteUserSalesAdminImage: `${API_BASE_URL}/api/v1/sales-admin/user-image`,
  deleteCAImage: `${API_BASE_URL}/api/v1/content-admin/user-image`,
  deleteCEImage: `${API_BASE_URL}/api/v1/chief-editor/post-image`,
  deleteUserJEImage: `${API_BASE_URL}/api/v1/junior-editor/post-image`,
  deleteUserUpImage: `${API_BASE_URL}/api/v1/uploader/post-image`,
  deleteUserPublisherImage: `${API_BASE_URL}/api/v1/publisher/post-image`,

  deleteCECompanyImage: `${API_BASE_URL}/api/v1/chief-editor/company-image`,
  deleteJECompanyImage: `${API_BASE_URL}/api/v1/junior-editor/company-image`,

  getPatients: `${API_BASE_URL}/api/v1/patient-info/get-patients`,
  getViewPatntDetails: `${API_BASE_URL}/api/v1/patient-info/patient`,
  getSavedList: `${API_BASE_URL}/api/v1/patient-info/get-saved-posts`,
  getReadHistory: `${API_BASE_URL}/api/v1/patient-info/get-post-read-history`,
  getSubscriptionData: `${API_BASE_URL}/api/v1/patient-info/subscription`,
  getPatientDetails: `${API_BASE_URL}/api/v1/patient-info/get-patient-details`,

  gerServiceReq: `${API_BASE_URL}/api/v1/sales-admin/get-service-req`,
  getSMServicereq: `${API_BASE_URL}/api/v1/sales-manager/get-service-req`,
  getSEServicereq: `${API_BASE_URL}/api/v1/sales-executive/get-service-req`,
  getTlServiceReq: `${API_BASE_URL}/api/v1/sales-team-lead/get-service-req`,
  getAllEmailsData: `${API_BASE_URL}/api/v1/sales-admin/get-all-subscriptions-emails`,
  getProfile: `${API_BASE_URL}/api/v1/vendor/get-hospital`,
  getCompanyProfile: `${API_BASE_URL}/api/v1/vendor/get-company`,
  saveProfile: `${API_BASE_URL}/api/v1/vendor/save-hospital`,
  saveCompanyProfile: `${API_BASE_URL}/api/v1/vendor/save-company`,
  saveEventOrganizer: `${API_BASE_URL}/api/v1/vendor/save-event-organizer`,
  getEventOrganizer: `${API_BASE_URL}/api/v1/vendor/get-event-organizer`,

  convertProposal: `${API_BASE_URL}/api/v1/lead/convert-to-proposal`,
  getProposalBooking: `${API_BASE_URL}/api/v1/lead/get-proposal-bookings`,
  getLeadProposal: `${API_BASE_URL}/api/v1/lead/proposal`,
  updateProposal: `${API_BASE_URL}/api/v1/lead/update-proposal`,
  saveProposal: `${API_BASE_URL}/api/v1/lead/save-proposal`,

  declinedProposal: `${API_BASE_URL}/api/v1/lead/decline-proposal`,
  convertBooking: `${API_BASE_URL}/api/v1/lead/convert-to-booking`,
  getDeclinedProposals: `${API_BASE_URL}/api/v1/lead/get-declined-proposals`,
  activateProposal: `${API_BASE_URL}/api/v1/lead/activate-proposal`,
  activateServices: `${API_BASE_URL}/api/v1/lead/activate-services`,
  getActiveVendors: `${API_BASE_URL}/api/v1/lead/get-active-vendors`,
  getInActiveVendors: `${API_BASE_URL}/api/v1/lead/get-inactive-vendors`,
  proposalBooking: `${API_BASE_URL}/api/v1/lead/proposal-bookings`,
  getActiveServiceReq: `${API_BASE_URL}/api/v1/lead/get-active-service-req`,
  getActivatedServices: `${API_BASE_URL}/api/v1/dashboard/get-activated-services`,
  getEdms: `${API_BASE_URL}/api/v1/dashboard/get-edms`,
  saveEdms: `${API_BASE_URL}/api/v1/dashboard/save-edm`,
  updateEdms: `${API_BASE_URL}/api/v1/dashboard/update-edm`,
  edmCount: `${API_BASE_URL}/api/v1/dashboard/edm-count`,
  getEdmData: `${API_BASE_URL}/api/v1/dashboard/edm`,
  getPrintADs: `${API_BASE_URL}/api/v1/dashboard/get-print-ads`,
  updatePrintAd: `${API_BASE_URL}/api/v1/dashboard/update-print-ad`,
  getPrintAdData: `${API_BASE_URL}/api/v1/dashboard/print-ad`,
  savePrintAd: `${API_BASE_URL}/api/v1/dashboard/save-print-ad`,
  getENews: `${API_BASE_URL}/api/v1/dashboard/get-e-news-ads`,
  saveENews: `${API_BASE_URL}/api/v1/dashboard/save-e-news-ad`,
  updateEnEWS: `${API_BASE_URL}/api/v1/dashboard/update-e-news-ad`,
  getEnewsAdd: `${API_BASE_URL}/api/v1/dashboard/e-news-ad`,

  getEwebsite: `${API_BASE_URL}/api/v1/dashboard/get-website-ads`,
  saveWebsiteAd: `${API_BASE_URL}/api/v1/dashboard/save-website-ad`,
  updateWebsiteAd: `${API_BASE_URL}/api/v1/dashboard/update-website-ad`,
  getWebsiteAd: `${API_BASE_URL}/api/v1/dashboard/website-ad`,
  searchCity: `${API_BASE_URL}/api/v1/logged-in-user/places-api`,
  post: `${API_BASE_URL}/api/v1/sales-admin/post`,
  event: `${API_BASE_URL}/api/v1/sales-admin/event`,
  matState: `${API_BASE_URL}/api/v1/master/mt-state`,
  getInvoice: `${API_BASE_URL}/api/v1/lead/get-invoice`,
  readersPersonalInfo: `${API_BASE_URL}/api/v1/reader/personal-info`,
  deleteEvent: `${API_BASE_URL}/api/v1/dashboard/delete-event`,
  deletePost: `${API_BASE_URL}/api/v1/content-admin/post`,
  getContactUsEnquiries: `${API_BASE_URL}/api/v1/enquiry/get-contact-us-enquiries`,
  getPostsEnquiries: `${API_BASE_URL}/api/v1/enquiry/get-post-enquiries`,
  getEventEnquiries: `${API_BASE_URL}/api/v1/enquiry/get-event-enquiries`,
  suspendVendor: `${API_BASE_URL}/api/v1/sales-admin/suspend-vendor`,

  getVendorEnquiries: `${API_BASE_URL}/api/v1/enquiry/get-vendor-enquiries`,
  uploadSignedRemEmail: `${API_BASE_URL}/api/v1/lead/upload-signed-form-rem-mail`,
  getAuthors: `${API_BASE_URL}/api/v1/dashboard/get-authors`,
  listEvent: `${API_BASE_URL}/api/v1/lead/list-events`,
  unListEvent: `${API_BASE_URL}/api/v1/lead/un-list-events`,

  addSeoSettings: `${API_BASE_URL}/api/v1/seo/save`,
  updateSeoSettings: `${API_BASE_URL}/api/v1/seo/update`,

  getSeoByName: `${API_BASE_URL}/api/v1/seo/get-by-name`,
  hospitalProfilling: `${API_BASE_URL}/api/v1/public/hospital-profiling`,
  companyProfilling: `${API_BASE_URL}/api/v1/public/company-profiling`,
  eventProfilling: `${API_BASE_URL}/api/v1/public/get-event-organizer`,

  addTagSeoSettings: `${API_BASE_URL}/api/v1/chief-editor/save-tag-seo `,
  addSectorSeoSettings: `${API_BASE_URL}/api/v1/chief-editor/save-sector-seo`,

  getTagSeoSettings: `${API_BASE_URL}/api/v1/chief-editor/tag`,
  getSectorSeoSettings: `${API_BASE_URL}/api/v1/chief-editor/sector`,
};

// Create an Axios instance
const API = axios.create({
  baseURL: API_BASE_URL, // Replace with your API URL
  headers: {
    accept: 'application/json, text/plain',
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add the token to the headers
API.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      // Ensure config.headers is defined
      if (!config.headers) {
        // config.headers = {};
        config.headers = new AxiosHeaders();
      }
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses and errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized error (e.g., redirect to login)
      // You can also clear the token or show an error message here
    }
    return Promise.reject(error);
  }
);

export const get = API.get;
export const post = API.post;
export const put = API.put;
export const deleteMethod = API.delete;

export default API;
